// import { Link } from "react-router-dom"
import styled from "styled-components"

export const BannerOverlaySubtext = styled.p`
  color: white;
  font-family: roboto;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.3rem;
  font-weight: 600;
`

export const BannerOverlaySubtext1 = styled.p`
  color: white;
  font-family: roboto;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.3rem;
  font-weight: 600;
  padding: 0% 3%;
  z-index: 1;

  @media ${({ theme }) => theme.mediaQueries.mobile} {
    padding: 0% 3%;
    font-size: 0.7rem;
    opacity: 0.8;
    letter-spacing: 0.28rem;
  }

  @media ${({ theme }) => theme.mediaQueries.mobile_landscape} {
    font-size: 0.7rem;
    -webkit-letter-spacing: 0.2rem;
    -moz-letter-spacing: 0.2rem;
    -ms-letter-spacing: 0.2rem;
    letter-spacing: 0.2rem;
    opacity: 0.8;
  }
`

export const BannerOverlayText = styled.h1`
  color: white;
  font-family: graphik;
  font-size: 3.5rem;
  letter-spacing: 0.1rem;
  font-weight: 700;
  width: 40%;
  margin-top: 4rem;
`

export const BannerOverlayText2 = styled.h1`
  color: white;
  font-family: graphik;
  font-size: 3.5rem;
  letter-spacing: 0.1rem;
  font-weight: 700;
  width: 40%;
  margin-top: 4rem;

  @media ${({ theme }) => theme.mediaQueries.mobile} {
    font-size: 1.5rem;
    font-weight: 800;
    width: 100%;
    line-height: 2.5rem;
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  @media ${({ theme }) => theme.mediaQueries.mobile_landscape} {
    font-size: 1.5rem;
    font-weight: 800;
    width: 100%;
    line-height: 2.5rem;
    margin-top: 2rem;
    margin-bottom: 3rem;
  }
`

export const BannerOverlayText3 = styled.h1`
  color: white;
  font-family: graphik;
  font-size: 3.5rem;
  letter-spacing: 0.1rem;
  font-weight: 700;
  width: 90%;
  margin-top: 6rem;

  @media ${({ theme }) => theme.mediaQueries.mobile} {
    font-size: 1.5rem;
    font-weight: 800;
    width: 100%;
    line-height: 2.5rem;
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  @media ${({ theme }) => theme.mediaQueries.mobile_landscape} {
    font-weight: 800;
    font-size: 1.8rem;
    width: 68%;
    line-height: 2.5rem;
    margin: 0%;
    margin-top: 6%;
  }
`

export const BannerOverlayText4 = styled.h1`
  color: white;
  font-family: graphik;
  font-size: 3.5rem;
  letter-spacing: 0.1rem;
  font-weight: 700;
  width: 90%;
  margin-top: 4rem;

  @media ${({ theme }) => theme.mediaQueries.mobile} {
    font-size: 1.5rem;
    font-weight: 800;
    width: 100%;
    line-height: 2.5rem;
    margin-top: 0rem;
    margin-bottom: 3rem;
  }

  @media ${({ theme }) => theme.mediaQueries.mobile_landscape} {
    font-weight: 800;
    font-size: 1.8rem;
    width: 68%;
    line-height: 2.5rem;
    margin: 0%;
    margin-top: 6%;
  }
`

export const BannerOverlayText1 = styled.h1`
  color: white;
  font-family: graphik;
  font-size: 3.5rem;
  letter-spacing: 0.1rem;
  font-weight: 700;
  width: 90%;
  margin-top: 6rem;

  @media ${({ theme }) => theme.mediaQueries.mobile} {
    font-size: 1.5rem;
    font-weight: 800;
    width: 100%;
    line-height: 2.5rem;
    margin-top: 3rem;
    margin-bottom: 5rem;
  }

  @media ${({ theme }) => theme.mediaQueries.mobile_landscape} {
    font-weight: 800;
    font-size: 1.8rem;
    width: 68%;
    line-height: 2.5rem;
    margin: 0%;
    margin-top: 1rem;
  }
  @media ${({ theme }) => theme.mediaQueries.tablet}{
    font-size: 2.2rem;
    margin-top: 5rem;
  }
`

export const ActionLinks = styled.p`
  color: white;
  font-size: 0.8rem;
  font-family: "Roboto";
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.1rem;
`

export const ActionLinks3 = styled.p`
  color: white;
  font-size: 0.8rem;
  font-family: "Roboto";
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.1rem;

  text-transform: none;
  line-height: 2;
  font-weight: 400;
  letter-spacing: 0.08rem;
  font-size: 1rem;
  margin-bottom: 1rem;

  @media ${({ theme }) => theme.mediaQueries.mobile} {
    letter-spacing: 0.08rem;
    line-height: 2;
    font-weight: 300;
    width: 92%;
    font-size: 0.8rem;
  }
  @media ${({ theme }) => theme.mediaQueries.ipad_pro}{
    width: 120%;
    margin-left:5rem;
  }
`

export const ActionLinks2 = styled.p`
  color: white;
  font-size: 0.8rem;
  font-family: "Roboto";
  letter-spacing: 0.08rem;
  line-height: 2;
  font-weight: 400;
  width: 50%;

  @media ${({ theme }) => theme.mediaQueries.mobile} {
    letter-spacing: 0.08rem;
    line-height: 2;
    font-weight: 300;
    width: 92%;
  }

  @media ${({ theme }) => theme.mediaQueries.mobile_landscape} {
    text-transform: none;
    line-height: 2;
    font-weight: 300;
    width: 84%;
    -webkit-letter-spacing: 0.08rem;
    -moz-letter-spacing: 0.08rem;
    -ms-letter-spacing: 0.08rem;
    -webkit-letter-spacing: 0.08rem;
    -moz-letter-spacing: 0.08rem;
    -ms-letter-spacing: 0.08rem;
    letter-spacing: 0.08rem;
    font-size: 0.75rem;
  }
  @media ${({ theme }) => theme.mediaQueries.tablet}{
    margin-left: 2rem;
    width: 70%;
  }
`

export const ActionLinks1 = styled.p`
  color: white;
  font-size: 0.8rem;
  font-family: "Roboto";
  text-transform: none;
  line-height: 2;
  font-weight: 400;
  width: 48%;
  letter-spacing: 0.08rem;

  @media ${({ theme }) => theme.mediaQueries.mobile} {
    letter-spacing: 0.08rem;
    text-transform: none;
    line-height: 2;
    font-weight: 300;
    width: 92%;
  }

  @media ${({ theme }) => theme.mediaQueries.mobile_landscape} {
    text-transform: none;
    line-height: 2;
    font-weight: 300;
    width: 92%;
    -webkit-letter-spacing: 0.08rem;
    -moz-letter-spacing: 0.08rem;
    -ms-letter-spacing: 0.08rem;
    -webkit-letter-spacing: 0.08rem;
    -moz-letter-spacing: 0.08rem;
    -ms-letter-spacing: 0.08rem;
    letter-spacing: 0.08rem;
    font-size: 0.75rem;
  }
`
